import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseKnowledgeBase } from 'entities/KnowledgeBase'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseKnowledgeBase) => void

export const useEventKnowledgeBaseUpdated = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.KnowledgeBaseUpdated, handler), [])
}
